import { Controller } from 'react-hook-form';
import {
  InputText,
  InputSize,
  DateInput,
  DateInputSize,
  Textarea,
} from '@ui/src';
import { GeneralInfoRowTypes } from './types';

import cn from './aml.module.css';

const AmlGeneralInfoRow = ({
  title,
  className,
  control,
  type,
  name,
  disabled,
  value: questionnaireValue,
}: GeneralInfoRowTypes) => (
  <div className={`${cn.amlGeneralInfoRow} ${className || ''}`}>
    <div className={cn.amlGeneralInfoRowTitle}>{title}</div>
    <div className={cn.amlGeneralInfoRowValue}>
      {!control && <div>{questionnaireValue}</div>}
      {control && name && (
        <Controller
          control={control}
          defaultValue=""
          name={name}
          render={({ field: { value, name: inputName, onChange } }) => {
            let content = <div />;

            if (type === 'text') {
              content = (
                <InputText
                  name={inputName}
                  value={value as string}
                  onChange={onChange}
                  size={InputSize.SMALL}
                  className="borderless"
                  placeholder=""
                  disabled={disabled}
                />
              );
            } else if (type === 'date') {
              content = (
                <DateInput
                  value={value as string}
                  placeholder="Select date"
                  onChange={(date) => {
                    onChange(date.toISOString());
                  }}
                  size={DateInputSize.SMALL}
                  disabled={disabled}
                  borderless
                  withoutCustomSelector
                />
              );
            } else if (type === 'textarea') {
              content = (
                <Textarea
                  name="businessLicense"
                  placeholder="Enter license..."
                  onChange={(e) => {
                    onChange(e);
                  }}
                  value={value as string}
                  disabled={disabled}
                  className={`borderless ${cn.rowTextarea}`}
                />
              );
            }

            return content;
          }}
        />
      )}
    </div>
  </div>
);

export default AmlGeneralInfoRow;
